import { Controller } from "@hotwired/stimulus";
import { FetchRequest } from "@rails/request.js";

export default class extends Controller {
  static targets = ["subscribeBtn"];
  static values = {
    publicKey: String,
    serverPath: String,
  };

  create() {
    this.swRegistration?.pushManager
      .subscribe({
        userVisibleOnly: true,
        applicationServerKey: this.publicKeyValue,
      })
      .then((subscription) => {
        console.log("User is subscribed.");
        this.updateSubscriptionOnServer(subscription);
        this.test();
      })
      .catch(function (error) {
        console.error("Failed to subscribe the user: ", error);
      });
  }

  connect() {
    if ("serviceWorker" in navigator && "PushManager" in window) {
      navigator.serviceWorker
        .ready
        .then((swRegistration) => {
          console.log("Service Worker is ready");
          this.swRegistration = swRegistration;
        })
        .catch((error) => {
          console.error("Error during service worker registration:", error);
          this.subscribeBtnTarget.disabled = true;
        });
    } else {
      console.warn("Push messaging is not supported");
      this.subscribeBtnTarget.disabled = true;
    }
  }

  async updateSubscriptionOnServer(subscription) {
    if (subscription) {
      const applicationServerUrl = this.serverPathValue;
      const request = new FetchRequest("post", applicationServerUrl, {
        body: JSON.stringify({ web_push_subscription: subscription }),
      });
      const response = await request.perform();
      if (response.ok) {
        console.log("Web push subscription updated on server.");
        location.reload();
      } else {
        console.error("Failed to update web push subscription on server:", response);
      }
    } else {
      // we probably want to unsubscribe the user on the server, too
    }
  }

  test() {
    this.swRegistration?.showNotification("Fluggr", {
      body: "Welcome! Notifications are enabled.",
      data: { url: "#" },
    });
  }
}
